var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { DatagridConfigurable, List, TextField, TextInput, BooleanField, WrapperField, useRefresh, useNotify, useGetList, useGetOne, FunctionField, Button as ReactAdminButton, useRecordContext, BooleanInput, DateInput, useSidebarState, useUnselectAll, useListContext, ReferenceArrayField, SingleFieldList, } from "react-admin";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useTenantStore } from "@/providers/TenantContextProvider";
import UploadIcon from "@mui/icons-material/Upload";
import { ListActions } from "@/components/ListActions";
import { Box, Button, Checkbox, Chip, FormControlLabel, Menu, MenuItem, Skeleton, Stack, Typography, } from "@mui/material";
import { Dialog, theme } from "@sequentech/ui-essentials";
import { useTranslation } from "react-i18next";
import EditIcon from "@mui/icons-material/Edit";
import MailIcon from "@mui/icons-material/Mail";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import PasswordIcon from "@mui/icons-material/Password";
import ArticleIcon from "@mui/icons-material/Article";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FilterAlt from "@mui/icons-material/FilterAlt";
import { EditUser } from "./EditUser";
import { AudienceSelection, SendTemplate } from "./SendTemplate";
import { CreateUser } from "./CreateUser";
import { AuthContext } from "@/providers/AuthContextProvider";
import { DELETE_USER } from "@/queries/DeleteUser";
import { MANUAL_VERIFICATION } from "@/queries/ManualVerification";
import { useMutation, useQuery } from "@apollo/client";
import { ATTR_RESET_VALUE, IPermissions } from "@/types/keycloak";
import { isDatafixElectionEvent } from "@/services/Datafix";
import { ResourceListStyles } from "@/components/styles/ResourceListStyles";
import { EElectionEventWeightedVotingPolicy, ESupportMaterialsPolicy, getEffectiveSupportMaterialsPolicy, parseEntityPresentation, translate, } from "@sequentech/ui-core";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { ImportDataDrawer } from "@/components/election-event/import-data/ImportDataDrawer";
import { FormStyles } from "@/components/styles/FormStyles";
import { EXPORT_USERS } from "@/queries/ExportUsers";
import { EXPORT_TENANT_USERS } from "@/queries/ExportTenantUsers";
import { DownloadDocument } from "./DownloadDocument";
import { IMPORT_USERS } from "@/queries/ImportUsers";
import { ElectoralLogFilters, ElectoralLogList } from "@/components/ElectoralLogList";
import { USER_PROFILE_CONFIGURATION } from "@/queries/GetUserProfileConfiguration";
import { getTranslationLabel, isHiddenAttribute, isSecretAttribute, getConfiguredSecretAttributeNames, userBasicInfo, } from "@/services/UserService";
import CustomDateField from "./CustomDateField";
import { ListActionsMenu } from "@/components/ListActionsMenu";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import { ReconciliationWizard } from "@/resources/VoterListSync/ReconciliationWizard";
import EditPassword from "./EditPassword";
import { styled } from "@mui/material/styles";
import { DELETE_USERS } from "@/queries/DeleteUsers";
import { buildUserFilterPayload } from "@/queries/GetUsers";
import { ETasksExecution } from "@/types/tasksExecution";
import { useWidgetStore } from "@/providers/WidgetsContextProvider";
import SelectArea from "@/components/area/SelectArea";
import { ThreeStateDatagridHeader } from "@/components/ThreeStateDatagridHeader";
import { useElectionEventTallyStore } from "@/providers/ElectionEventTallyProvider";
import { UserActionTypes } from "@/components/types";
import { useUsersPermissions } from "./useUsersPermissions";
import { Check, FilterAltOff } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import { getPreferenceKey } from "@/lib/helpers";
import { isEqual } from "lodash";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
import { GENERATE_VOTER_INFORMATION_LETTER } from "@/queries/VoterInformationLetter";
import { VoterInformationLetterPasswordAccess } from "@/resources/Tasks/VoterInformationLetterPasswordAccess";
import { getVoterInformationLetterPasswordPolicyError } from "./editPasswordError";
export var AUTHORIZED_ELECTION_IDS = "authorized-election-ids";
export var VOTED_CHANNEL = "voted-channel";
export var DISABLE_COMMENT = "disable-comment";
export var SUPPORT_MATERIALS_ACKNOWLEDGED = "support-materials-acknowledged";
export var VOTE_WEIGHT = "vote-weight";
var DataGridContainerStyle = styled(DatagridConfigurable, {
    shouldForwardProp: function (prop) { return prop !== "isOpenSideBar"; }, // Prevent `isOpenSideBar` from being passed to the DOM
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media (min-width: ", "px) {\n        overflow-x: auto;\n        width: 100%;\n        ", "\n        &  > div:first-of-type {\n            position: absolute;\n            width: 100%;\n        }\n    }\n"], ["\n    @media (min-width: ", "px) {\n        overflow-x: auto;\n        width: 100%;\n        ", "\n        &  > div:first-of-type {\n            position: absolute;\n            width: 100%;\n        }\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.values.md;
}, function (_a) {
    var isOpenSideBar = _a.isOpenSideBar;
    return "max-width: ".concat(isOpenSideBar ? "calc(100vw - 355px)" : "calc(100vw - 108px)", ";");
});
var StyledChip = styled(Chip)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: 4px;\n"], ["\n    margin: 4px;\n"])));
var StyledNull = styled("div")(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: block;\n    padding-left: 18px;\n"], ["\n    display: block;\n    padding-left: 18px;\n"])));
export var ListUsers = function (_a) {
    var _b;
    var _c, _d, _e;
    var aside = _a.aside, electionEventId = _a.electionEventId, electionId = _a.electionId;
    var _f = useTranslation(), t = _f.t, i18n = _f.i18n;
    var tenantId = useTenantStore()[0];
    // The Voted Channel attribute can only ever be written by the Datafix
    // integration, so the column and filter are gated on the event being
    // configured for it. The event record is not otherwise in scope here.
    var electionEventRecord = useGetOne("sequent_backend_election_event", { id: electionEventId, meta: { tenant_id: tenantId } }, { enabled: Boolean(electionEventId && tenantId) }).data;
    var isDatafixEvent = isDatafixElectionEvent(electionEventRecord);
    var isSupportMaterialsMandatory = getEffectiveSupportMaterialsPolicy((_c = electionEventRecord === null || electionEventRecord === void 0 ? void 0 : electionEventRecord.presentation) === null || _c === void 0 ? void 0 : _c.materials) ===
        ESupportMaterialsPolicy.MANDATORY_FOR_VOTING;
    // A voter has "viewed" Support Materials only once they've acknowledged
    // every currently visible material for this Election Event, so the
    // Voters list column/filter needs the full current set to compare
    // against each voter's attributes['support-materials-acknowledged'].
    var supportMaterialsList = useGetList("sequent_backend_support_material", {
        pagination: { page: 1, perPage: 9999 },
        filter: {
            tenant_id: tenantId,
            election_event_id: electionEventId,
            is_hidden: false,
        },
    }, { enabled: Boolean(electionEventId && tenantId && isSupportMaterialsMandatory) }).data;
    var requiredSupportMaterialDocumentIds = useMemo(function () {
        return (supportMaterialsList !== null && supportMaterialsList !== void 0 ? supportMaterialsList : [])
            .map(function (material) { return material.document_id; })
            .filter(function (documentId) { return Boolean(documentId); });
    }, [supportMaterialsList]);
    var globalSettings = useContext(SettingsContext).globalSettings;
    var isOpenSidebar = useSidebarState()[0];
    var location = useLocation();
    var aliasRenderer = useAliasRenderer();
    var _g = useState(false), open = _g[0], setOpen = _g[1];
    var _h = useState(false), openExport = _h[0], setOpenExport = _h[1];
    var _j = useState(false), includeSecretAttributes = _j[0], setIncludeSecretAttributes = _j[1];
    var _k = useState(false), exporting = _k[0], setExporting = _k[1];
    var _l = useState(null), userType = _l[0], setUserType = _l[1];
    var _m = useState(), exportDocumentId = _m[0], setExportDocumentId = _m[1];
    var _o = useState(false), openNew = _o[0], setOpenNew = _o[1];
    var _p = useState(AudienceSelection.SELECTED), audienceSelection = _p[0], setAudienceSelection = _p[1];
    var _q = useState(null), documentId = _q[0], setDocumentId = _q[1];
    var _r = useWidgetStore(), addWidget = _r[0], setWidgetTaskId = _r[1], updateWidgetFail = _r[2];
    var _s = React.useState(false), openUsersLogsModal = _s[0], setOpenUsersLogsModal = _s[1];
    var _t = React.useState(false), openSendTemplate = _t[0], setOpenSendTemplate = _t[1];
    var _u = React.useState(false), openDeleteModal = _u[0], setOpenDeleteModal = _u[1];
    var _v = React.useState(false), openManualVerificationModal = _v[0], setOpenManualVerificationModal = _v[1];
    var _w = React.useState(false), openDeleteBulkModal = _w[0], setOpenDeleteBulkModal = _w[1];
    var _x = useState(false), deletingBulk = _x[0], setDeletingBulk = _x[1];
    var _y = React.useState(false), openEditPassword = _y[0], setOpenEditPassword = _y[1];
    var _z = useState(false), openVoterInformationLetter = _z[0], setOpenVoterInformationLetter = _z[1];
    var _0 = useState(), voterInformationLetterPassword = _0[0], setVoterInformationLetterPassword = _0[1];
    var _1 = useState(false), generatingVoterInformationLetter = _1[0], setGeneratingVoterInformationLetter = _1[1];
    var _2 = useState([]), selectedIds = _2[0], setSelectedIds = _2[1];
    var filterValuesRef = useRef({});
    // What the pending bulk delete will actually act on. `selectAll` means
    // every voter matching the active filters, which only the server can
    // enumerate -- the browser holds one page.
    var _3 = useState({ selectedCount: 0, matchingCount: 0 }), deleteScope = _3[0], setDeleteScope = _3[1];
    var _4 = useState(), deleteId = _4[0], setDeleteId = _4[1];
    var _5 = useState(false), openDrawer = _5[0], setOpenDrawer = _5[1];
    var _6 = useState(false), openImportDrawer = _6[0], setOpenImportDrawer = _6[1];
    var _7 = useState(false), openReconciliationWizard = _7[0], setOpenReconciliationWizard = _7[1];
    var _8 = useState([]), recordIds = _8[0], setRecordIds = _8[1];
    var _9 = useState(), userRecord = _9[0], setUserRecord = _9[1];
    var authContext = useContext(AuthContext);
    var refresh = useRefresh();
    var unselectAll = useUnselectAll("user");
    var deleteUser = useMutation(DELETE_USER)[0];
    var getManualVerificationPdf = useMutation(MANUAL_VERIFICATION)[0];
    var deleteUsers = useMutation(DELETE_USERS)[0];
    var exportUsers = useMutation(EXPORT_USERS)[0];
    var generateVoterInformationLetter = useMutation(GENERATE_VOTER_INFORMATION_LETTER, {
        fetchPolicy: "no-cache",
        context: { headers: { "x-hasura-role": IPermissions.VOTER_INFORMATION_LETTER } },
    })[0];
    var PHONE_NUMBER_USER_ATTRIBUTE = "sequent.read-only.mobile-number";
    var userProfileConfiguration = useQuery(USER_PROFILE_CONFIGURATION, {
        variables: {
            tenantId: tenantId,
            electionEventId: electionEventId,
        },
    }).data;
    // Keep the existing list/filter consumers on their current attributes-only
    // shape while create/edit also receives the new group metadata.
    var userAttributes = useMemo(function () {
        return userProfileConfiguration
            ? {
                get_user_profile_attributes: userProfileConfiguration.get_user_profile_configuration.attributes,
            }
            : undefined;
    }, [userProfileConfiguration]);
    var userAttributeGroups = (_d = userProfileConfiguration === null || userProfileConfiguration === void 0 ? void 0 : userProfileConfiguration.get_user_profile_configuration.groups) !== null && _d !== void 0 ? _d : [];
    var secretAttributeNames = useMemo(function () { return getConfiguredSecretAttributeNames(userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes); }, [userAttributes]);
    var visibleUserAttributes = useMemo(function () {
        var _a, _b;
        // Attributes hidden from the voter-facing forms are also kept out of
        // the admin columns, filters, and forms. Username is the exception: it
        // remains visible to administrators as Keycloak's built-in identifier.
        var attributes = (_a = userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes) === null || _a === void 0 ? void 0 : _a.filter(function (attribute) { return !isHiddenAttribute(attribute); });
        if (!attributes || !electionEventId) {
            return attributes;
        }
        var weightedVotingPolicy = (_b = parseEntityPresentation(electionEventRecord === null || electionEventRecord === void 0 ? void 0 : electionEventRecord.presentation)) === null || _b === void 0 ? void 0 : _b.weighted_voting_policy;
        return weightedVotingPolicy === EElectionEventWeightedVotingPolicy.VOTERS_WEIGHTED_VOTING
            ? attributes
            : attributes.filter(function (attribute) { return attribute.name !== VOTE_WEIGHT; });
    }, [electionEventId, electionEventRecord === null || electionEventRecord === void 0 ? void 0 : electionEventRecord.presentation, userAttributes]);
    var Filters = useMemo(function () {
        var filters = [];
        if (visibleUserAttributes) {
            filters = visibleUserAttributes
                // Has its own dedicated boolean column/handling, not a generic
                // text filter.
                .filter(function (attr) {
                return !isSecretAttribute(attr) && attr.name !== SUPPORT_MATERIALS_ACKNOWLEDGED;
            })
                .map(function (attr) {
                var _a, _b;
                //covert to valid source string (if attr name is for example sequent.read-only.otp-method)
                var source = (_a = attr.name) === null || _a === void 0 ? void 0 : _a.replaceAll(".", "%");
                if (((_b = attr.annotations) === null || _b === void 0 ? void 0 : _b.inputType) === "html5-date") {
                    return (_jsx(DateInput, { source: "attributes.".concat(attr.name), label: getTranslationLabel(attr.name, attr.display_name, t) }, attr.name));
                }
                return (_jsx(TextInput, { source: userBasicInfo.includes("".concat(attr.name))
                        ? "".concat(attr.name, ".IsLike")
                        : "attributes.".concat(source), label: getTranslationLabel(attr.name, attr.display_name, t) }, attr.name));
            });
            filters.push(_jsx(BooleanInput, { source: "enabled" }, "enabled"));
            filters.push(_jsx(BooleanInput, { source: "email_verified" }, "email_verified"));
            if (electionEventId) {
                filters.push(_jsx(SelectArea, { tenantId: tenantId, electionEventId: electionEventId, source: "attributes.area-id", label: String(t("usersAndRolesScreen.users.fields.area")) }));
            }
            if (electionEventId) {
                filters.push(_jsx(BooleanInput, { source: "has_voted", label: String(t("usersAndRolesScreen.users.fields.has_voted")) }, "has_voted"));
                if (isDatafixEvent) {
                    filters.push(_jsx(TextInput, { source: "attributes.".concat(VOTED_CHANNEL), label: String(t("usersAndRolesScreen.users.fields.voted-channel")) }, VOTED_CHANNEL));
                }
            }
        }
        return filters;
    }, [visibleUserAttributes, isDatafixEvent]);
    var exportTenantUsers = useMutation(EXPORT_TENANT_USERS, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.USER_READ,
            },
        },
    })[0];
    var notify = useNotify();
    var rolesList = useGetList("role", {
        pagination: { page: 1, perPage: 9999 },
        sort: { field: "last_updated_at", order: "DESC" },
        filter: {
            tenant_id: tenantId,
        },
    }).data;
    /**
     * Permissions
     */
    var _10 = useUsersPermissions(), canImportUsers = _10.canImportUsers, canCreateVoters = _10.canCreateVoters, canEditVoters = _10.canEditVoters, canReadVoterSecretAttributes = _10.canReadVoterSecretAttributes, canEditVotersEmailTlf = _10.canEditVotersEmailTlf, canDeleteVoters = _10.canDeleteVoters, canImportVoters = _10.canImportVoters, canExportVoters = _10.canExportVoters, canManuallyVerify = _10.canManuallyVerify, canChangePassword = _10.canChangePassword, canGenerateVoterInformationLetter = _10.canGenerateVoterInformationLetter, showVotersColumns = _10.showVotersColumns, showVotersFilters = _10.showVotersFilters, showVotersLogs = _10.showVotersLogs, canSendTemplates = _10.canSendTemplates, showVoterListSync = _10.showVoterListSync;
    /**
     * Permissions
     */
    var handleClose = function () {
        setRecordIds([]);
        setOpenUsersLogsModal(false);
        setOpenSendTemplate(false);
        setOpenDeleteModal(false);
        setOpenManualVerificationModal(false);
        setOpenVoterInformationLetter(false);
        setVoterInformationLetterPassword(undefined);
        setOpenDeleteBulkModal(false);
        setOpenDrawer(false);
        setOpenNew(false);
        setOpen(false);
        unselectAll();
    };
    var editAction = function (id) {
        setOpen(true);
        setOpenNew(false);
        setOpenDeleteModal(false);
        setOpenManualVerificationModal(false);
        setOpenDeleteBulkModal(false);
        setOpenSendTemplate(false);
        setRecordIds([id]);
    };
    var sendTemplateForIdAction = function (id) {
        sendTemplateAction([id]);
    };
    var sendTemplateAction = function (ids, audienceSelection) {
        if (audienceSelection === void 0) { audienceSelection = AudienceSelection.SELECTED; }
        setOpen(false);
        setOpenNew(false);
        setOpenDeleteModal(false);
        setOpenManualVerificationModal(false);
        setOpenDeleteBulkModal(false);
        setOpenSendTemplate(true);
        setAudienceSelection(audienceSelection);
        setRecordIds(ids);
    };
    var deleteAction = function (id) {
        if (!electionEventId && authContext.userId === id) {
            return;
        }
        setOpen(false);
        setOpenNew(false);
        setOpenSendTemplate(false);
        setOpenManualVerificationModal(false);
        setOpenDeleteBulkModal(false);
        setOpenDeleteModal(true);
        setDeleteId(id);
    };
    var manualVerificationAction = function (id) {
        if (!electionEventId && authContext.userId === id) {
            return;
        }
        setOpen(false);
        setOpenNew(false);
        setOpenSendTemplate(false);
        setOpenManualVerificationModal(true);
        setOpenDeleteBulkModal(false);
        setOpenDeleteModal(false);
        setRecordIds([id]);
    };
    var editPasswordAction = function (id) {
        setOpen(false);
        setOpenNew(false);
        setOpenSendTemplate(false);
        setOpenManualVerificationModal(false);
        setOpenDeleteBulkModal(false);
        setOpenDeleteModal(false);
        setOpenEditPassword(true);
        setRecordIds([id]);
    };
    var voterInformationLetterAction = function (id) {
        if (!electionEventId) {
            return;
        }
        setOpen(false);
        setOpenNew(false);
        setOpenSendTemplate(false);
        setOpenManualVerificationModal(false);
        setOpenDeleteBulkModal(false);
        setOpenDeleteModal(false);
        setOpenEditPassword(false);
        setRecordIds([id]);
        setVoterInformationLetterPassword(undefined);
        setOpenVoterInformationLetter(true);
    };
    var confirmVoterInformationLetter = function () { return __awaiter(void 0, void 0, void 0, function () {
        var voterId, data, taskId, pdfPassword, widget, error_1, passwordPolicyError, notificationKey;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    voterId = recordIds[0];
                    if (!electionEventId || !voterId) {
                        return [2 /*return*/];
                    }
                    setGeneratingVoterInformationLetter(true);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, generateVoterInformationLetter({
                            variables: {
                                electionEventId: electionEventId,
                                voterId: String(voterId),
                            },
                        })];
                case 2:
                    data = (_d.sent()).data;
                    taskId = (_b = (_a = data === null || data === void 0 ? void 0 : data.generate_voter_information_letter) === null || _a === void 0 ? void 0 : _a.task_execution) === null || _b === void 0 ? void 0 : _b.id;
                    pdfPassword = (_c = data === null || data === void 0 ? void 0 : data.generate_voter_information_letter) === null || _c === void 0 ? void 0 : _c.pdf_password;
                    if (!taskId || !pdfPassword) {
                        throw new Error("Voter Information Letter access data was not returned");
                    }
                    widget = addWidget(ETasksExecution.VOTER_INFORMATION_LETTER, false);
                    setWidgetTaskId(widget.identifier, taskId);
                    notify(t("usersAndRolesScreen.voters.voterInformationLetter.generationStarted"), {
                        type: "success",
                    });
                    setOpenVoterInformationLetter(false);
                    setRecordIds([]);
                    setVoterInformationLetterPassword(pdfPassword);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _d.sent();
                    passwordPolicyError = getVoterInformationLetterPasswordPolicyError(error_1);
                    notificationKey = passwordPolicyError
                        ? {
                            notConfigured: "usersAndRolesScreen.voters.voterInformationLetter.policyNotConfigured",
                            minimumLengthMissing: "usersAndRolesScreen.voters.voterInformationLetter.policyMinimumLengthMissing",
                            characterClassMissing: "usersAndRolesScreen.voters.voterInformationLetter.policyCharacterClassMissing",
                        }[passwordPolicyError]
                        : "usersAndRolesScreen.voters.voterInformationLetter.generationError";
                    notify(t(notificationKey), { type: "error" });
                    setOpenVoterInformationLetter(false);
                    return [3 /*break*/, 5];
                case 4:
                    setGeneratingVoterInformationLetter(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var confirmManualVerificationAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, errors, data, docId;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, getManualVerificationPdf({
                        variables: {
                            tenantId: tenantId,
                            electionEventId: electionEventId,
                            voterId: recordIds[0],
                        },
                    })];
                case 1:
                    _a = _c.sent(), errors = _a.errors, data = _a.data;
                    if (errors) {
                        console.log("Error manually verifying user: ".concat(errors));
                        notify(t("usersAndRolesScreen.voters.notifications.manualVerificationError"), {
                            type: "error",
                        });
                        setRecordIds([]);
                        setOpenManualVerificationModal(false);
                        refresh();
                        return [2 /*return*/];
                    }
                    console.log("fetchData success: ".concat(data));
                    setRecordIds([]);
                    refresh();
                    docId = (_b = data === null || data === void 0 ? void 0 : data.get_manual_verification_pdf) === null || _b === void 0 ? void 0 : _b.document_id;
                    if (docId) {
                        setDocumentId(docId);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var confirmDeleteAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var errors;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, deleteUser({
                        variables: {
                            tenantId: tenantId,
                            electionEventId: electionEventId,
                            userId: deleteId,
                        },
                    })];
                case 1:
                    errors = (_a.sent()).errors;
                    if (errors) {
                        notify(t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".notifications.deleteError")), { type: "error" });
                        console.log("Error deleting user: ".concat(errors));
                        return [2 /*return*/];
                    }
                    notify(t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".notifications.deleteSuccess")), { type: "success" });
                    setDeleteId(undefined);
                    refresh();
                    return [2 /*return*/];
            }
        });
    }); };
    var showUsersLogsModal = function (id) {
        if (!electionEventId) {
            return;
        }
        setOpen(false);
        setOpenNew(false);
        setOpenSendTemplate(false);
        setOpenManualVerificationModal(false);
        setOpenDeleteBulkModal(false);
        setOpenDeleteModal(false);
        setOpenUsersLogsModal(true);
        setRecordIds([id]);
    };
    var actionsConfig = (_b = {},
        _b[UserActionTypes.COMMUNICATION] = {
            icon: _jsx(MailIcon, {}),
            action: sendTemplateForIdAction,
            showAction: function () { return canSendTemplates; },
            label: t("sendCommunication.send"),
        },
        _b[UserActionTypes.EDIT] = {
            icon: _jsx(EditIcon, { className: "edit-voter-icon" }),
            action: editAction,
            showAction: function () { return canEditVoters || canEditVotersEmailTlf; },
            label: t("common.label.edit"),
            saveRecordAction: setUserRecord,
        },
        _b[UserActionTypes.DELETE] = {
            icon: _jsx(DeleteIcon, { className: "delete-voter-icon" }),
            action: deleteAction,
            showAction: function () { return canDeleteVoters; },
            label: t("common.label.delete"),
            className: "delete-voter-icon",
        },
        _b[UserActionTypes.MANUAL_VERIFICATION] = {
            icon: _jsx(CreditScoreIcon, {}),
            action: manualVerificationAction,
            showAction: function () { return canManuallyVerify; },
            label: t("usersAndRolesScreen.voters.manualVerification.label"),
            saveRecordAction: setUserRecord,
        },
        _b[UserActionTypes.VOTER_INFORMATION_LETTER] = {
            icon: _jsx(ArticleIcon, {}),
            action: voterInformationLetterAction,
            showAction: function () { return canGenerateVoterInformationLetter; },
            label: t("usersAndRolesScreen.voters.voterInformationLetter.label"),
        },
        _b[UserActionTypes.PASSWORD] = {
            icon: _jsx(PasswordIcon, {}),
            action: editPasswordAction,
            showAction: function () { return canChangePassword; },
            label: t("usersAndRolesScreen.editPassword.label"),
        },
        _b[UserActionTypes.LOGS] = {
            icon: _jsx(VisibilityIcon, {}),
            action: showUsersLogsModal,
            showAction: function () { return showVotersLogs; },
            label: t("usersAndRolesScreen.voters.logs.label"),
        },
        _b);
    var actionByUserType = {
        user: [
            UserActionTypes.COMMUNICATION,
            UserActionTypes.EDIT,
            UserActionTypes.DELETE,
            UserActionTypes.PASSWORD,
        ],
        voter: [
            UserActionTypes.COMMUNICATION,
            UserActionTypes.EDIT,
            UserActionTypes.DELETE,
            UserActionTypes.MANUAL_VERIFICATION,
            UserActionTypes.VOTER_INFORMATION_LETTER,
            UserActionTypes.PASSWORD,
            UserActionTypes.LOGS,
        ],
    };
    function getActionsForUserType(userType) {
        var actionsByUserType = actionByUserType[userType] || [];
        var actions = actionsByUserType.map(function (actionType) { return actionsConfig[actionType]; });
        return actions;
    }
    var actions = useMemo(function () {
        var userType = electionEventId ? "voter" : "user";
        return getActionsForUserType(userType);
    }, [electionEventId]);
    function confirmDeleteBulkAction(selectAll) {
        return __awaiter(this, void 0, void 0, function () {
            var scopeKey, widget, failed, listFilters, _a, data, errors, taskId, error_2;
            var _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        scopeKey = electionEventId ? "voters" : "users";
                        setDeletingBulk(true);
                        widget = electionEventId
                            ? addWidget(ETasksExecution.DELETE_VOTERS, undefined)
                            : undefined;
                        failed = function () {
                            if (widget) {
                                updateWidgetFail(widget.identifier);
                            }
                            notify(t("usersAndRolesScreen.".concat(scopeKey, ".notifications.deleteError")), {
                                type: "error",
                            });
                        };
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, 4, 5]);
                        listFilters = selectAll
                            ? buildUserFilterPayload(__assign(__assign(__assign({}, filterValuesRef.current), myFilters), permanentFilters))
                            : undefined;
                        return [4 /*yield*/, deleteUsers({
                                variables: __assign({ tenantId: tenantId, electionEventId: electionEventId, electionId: electionId, usersId: selectAll ? undefined : selectedIds, selectAll: selectAll }, (listFilters !== null && listFilters !== void 0 ? listFilters : {})),
                            })];
                    case 2:
                        _a = _e.sent(), data = _a.data, errors = _a.errors;
                        if (errors || ((_b = data === null || data === void 0 ? void 0 : data.delete_users) === null || _b === void 0 ? void 0 : _b.error_msg)) {
                            failed();
                            return [2 /*return*/];
                        }
                        taskId = (_d = (_c = data === null || data === void 0 ? void 0 : data.delete_users) === null || _c === void 0 ? void 0 : _c.task_execution) === null || _d === void 0 ? void 0 : _d.id;
                        if (widget) {
                            taskId
                                ? setWidgetTaskId(widget.identifier, taskId)
                                : updateWidgetFail(widget.identifier);
                        }
                        notify(t("usersAndRolesScreen.".concat(scopeKey, ".notifications.multipleDeleteSuccess")), {
                            type: "success",
                        });
                        refresh();
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _e.sent();
                        // useMutation has no onError here, so Apollo rethrows.
                        failed();
                        return [3 /*break*/, 5];
                    case 4:
                        setDeletingBulk(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function BulkActions() {
        var _a = useListContext(), total = _a.total, filterValues = _a.filterValues, listSelectedIds = _a.selectedIds;
        // Kept in a ref so confirmDeleteBulkAction, which lives outside the
        // List context, sends the filters that were active when the operator
        // opened the dialog.
        filterValuesRef.current = filterValues !== null && filterValues !== void 0 ? filterValues : {};
        return (_jsxs(_Fragment, { children: [canSendTemplates && (_jsxs(Button, { variant: "actionbar", onClick: function () {
                        sendTemplateAction(listSelectedIds !== null && listSelectedIds !== void 0 ? listSelectedIds : [], AudienceSelection.SELECTED);
                    }, children: [_jsx(ResourceListStyles.MailIcon, {}), t("sendCommunication.send")] }, "send-notification")), canDeleteVoters && (_jsxs(Button, { variant: "actionbar", onClick: function () {
                        var ids = listSelectedIds !== null && listSelectedIds !== void 0 ? listSelectedIds : [];
                        setSelectedIds(ids);
                        // Both counts are offered to the operator; nothing
                        // is inferred from the selection. The header
                        // checkbox only ever selects the loaded page, so
                        // guessing intent from it would silently escalate a
                        // page-sized delete into an event-sized one.
                        setDeleteScope({
                            selectedCount: ids.length,
                            matchingCount: total !== null && total !== void 0 ? total : ids.length,
                        });
                        setOpenDeleteBulkModal(true);
                    }, children: [_jsx(ResourceListStyles.DeleteIcon, {}), t("common.label.delete")] }))] }));
    }
    var handleImport = function () {
        setOpenImportDrawer(true);
    };
    var handleExport = function () {
        setExporting(false);
        setExportDocumentId(undefined);
        setIncludeSecretAttributes(false);
        setOpenExport(true);
    };
    var confirmExportAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var currWidget, _a, exportUsersData, errors, task_id, _b, exportUsersData, errors, documentId_1, err_1;
        var _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 5, , 6]);
                    setExportDocumentId(undefined);
                    setExporting(true);
                    if (!electionEventId) return [3 /*break*/, 2];
                    currWidget = addWidget(ETasksExecution.EXPORT_VOTERS, true);
                    return [4 /*yield*/, exportUsers({
                            variables: {
                                tenantId: tenantId,
                                electionEventId: electionEventId,
                                electionId: electionId,
                                includeSecretAttributes: includeSecretAttributes,
                            },
                        })];
                case 1:
                    _a = _f.sent(), exportUsersData = _a.data, errors = _a.errors;
                    if (errors || !exportUsersData) {
                        setExporting(false);
                        setOpenExport(false);
                        updateWidgetFail(currWidget.identifier);
                        return [2 /*return*/];
                    }
                    task_id = (_d = (_c = exportUsersData === null || exportUsersData === void 0 ? void 0 : exportUsersData.export_users) === null || _c === void 0 ? void 0 : _c.task_execution) === null || _d === void 0 ? void 0 : _d.id;
                    task_id
                        ? setWidgetTaskId(currWidget.identifier, task_id)
                        : updateWidgetFail(currWidget.identifier);
                    setExporting(false);
                    setOpenExport(false);
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, exportTenantUsers({
                        variables: { tenantId: tenantId },
                    })];
                case 3:
                    _b = _f.sent(), exportUsersData = _b.data, errors = _b.errors;
                    if (errors || !exportUsersData) {
                        setExporting(false);
                        setOpenExport(false);
                        notify(t("usersAndRolesScreen.".concat("users", ".notifications.exportError")), {
                            type: "error",
                        });
                        return [2 /*return*/];
                    }
                    documentId_1 = (_e = exportUsersData.export_tenant_users) === null || _e === void 0 ? void 0 : _e.document_id;
                    setExportDocumentId(documentId_1);
                    _f.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    err_1 = _f.sent();
                    console.log(err_1);
                    currWidget && updateWidgetFail(currWidget.identifier);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var Empty = function () { return (_jsxs(ResourceListStyles.EmptyBox, { children: [_jsx(Typography, { variant: "h4", paragraph: true, children: t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".emptyHeader")) }), canCreateVoters ? (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "body1", paragraph: true, children: t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".askCreate")) }), _jsxs(ResourceListStyles.EmptyButtonList, { className: "voter-add-button", children: [_jsxs(Button, { onClick: function () { return setOpenNew(true); }, children: [_jsx(ResourceListStyles.CreateIcon, { icon: faPlus }), t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".create.subtitle"))] }), _jsx(ReactAdminButton, { onClick: handleImport, label: String(t("common.label.import")), children: _jsx(UploadIcon, {}) })] })] })) : null] })); };
    var electionEvent = useRecordContext();
    var importUsers = useMutation(IMPORT_USERS)[0];
    /**
     * added custom filter actions menu
     */
    var buttonRef = useRef(null);
    // state
    var _11 = useState([
        canSendTemplates ? (_jsxs(Button, { onClick: function () {
                sendTemplateAction([], AudienceSelection.ALL_USERS);
            }, children: [_jsx(ResourceListStyles.MailIcon, {}), t("sendCommunication.send")] }, "send-notification")) : (_jsx(_Fragment, {})),
    ]), listActions = _11[0], setListActions = _11[1];
    var _12 = useState(null), anchorEl = _12[0], setAnchorEl = _12[1];
    var _13 = useState(false), openCustomMenu = _13[0], setOpenCustomMenu = _13[1];
    var customFilter = useElectionEventTallyStore().customFilter;
    var _14 = useState({}), myFilters = _14[0], setMyFilters = _14[1];
    var _15 = useState(false), hasCustomFilter = _15[0], setHasCustomFilter = _15[1];
    var _16 = useState(null), selectedCustomItemMenu = _16[0], setSelectedCustomItemMenu = _16[1];
    // functions
    var handleClickCustomMenu = function (event) {
        setAnchorEl(event.currentTarget);
        setOpenCustomMenu(true);
    };
    var handleCloseCustomMenu = function () {
        setAnchorEl(null);
        setOpenCustomMenu(false);
    };
    var handleApplyCustomMenu = function (filter, index) {
        if (filter) {
            setMyFilters(function (prev) { return (__assign({}, filter)); });
            setHasCustomFilter(true);
        }
        else {
            setMyFilters({});
            setHasCustomFilter(false);
        }
        setSelectedCustomItemMenu(index);
        setAnchorEl(null);
        setOpenCustomMenu(false);
    };
    // effect
    useEffect(function () {
        setMyFilters(customFilter);
        setHasCustomFilter(false);
    }, [customFilter]);
    var permanentFilters = {
        tenant_id: tenantId,
        election_event_id: electionEventId,
        election_id: electionId,
    };
    useEffect(function () {
        var _a;
        if (electionEvent) {
            var customFilters = ((_a = electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.presentation) === null || _a === void 0 ? void 0 : _a.custom_filters) || [];
            if (customFilters.length > 0) {
                customFilters = __spreadArray([], customFilters, true);
                setListActions(function (prev) {
                    // prevent double adding the button
                    var customFilterExists = prev.some(function (action) { return action.key === "custom-filters"; });
                    // if it's not in the list of actions, add it
                    if (!customFilterExists) {
                        return __spreadArray(__spreadArray([], prev, true), [
                            _jsxs(Button, { ref: buttonRef, disableElevation: true, "aria-controls": openCustomMenu ? "basic-menu" : undefined, "aria-haspopup": "true", "aria-expanded": openCustomMenu ? "true" : undefined, variant: "contained", onClick: function (e) {
                                    var _a;
                                    handleClickCustomMenu(e);
                                    (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                                }, style: {
                                    backgroundColor: hasCustomFilter ? "#0F054C" : "#FFFFFF",
                                    color: hasCustomFilter ? "#FFFFFF" : "#0F054C",
                                }, children: [hasCustomFilter ? (_jsx(FilterAlt, { sx: { mr: 1 } })) : (_jsx(FilterAltOff, { sx: { mr: 1 } })), t("common.label.filter")] }, "custom-filters"),
                        ], false);
                    }
                    return prev;
                });
            }
        }
    }, [electionEvent]);
    // Force update when hasCustomFilter changes
    useEffect(function () {
        setListActions(function (prev) {
            return prev.map(function (action) {
                if (action.key === "custom-filters") {
                    return (_jsxs(Button, { ref: buttonRef, disableElevation: true, "aria-controls": openCustomMenu ? "basic-menu" : undefined, "aria-haspopup": "true", "aria-expanded": openCustomMenu ? "true" : undefined, variant: "contained", onClick: function (e) {
                            var _a;
                            handleClickCustomMenu(e);
                            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                        }, style: {
                            backgroundColor: hasCustomFilter ? "#0F054C" : "#FFFFFF",
                            color: hasCustomFilter ? "#FFFFFF" : "#0F054C",
                        }, children: [hasCustomFilter ? (_jsx(FilterAlt, { sx: { mr: 1 } })) : (_jsx(FilterAltOff, { sx: { mr: 1 } })), t("common.label.filter")] }, "custom-filters"));
                }
                return action;
            });
        });
    }, [hasCustomFilter]);
    // Direct DOM manipulation for background color
    useEffect(function () {
        if (buttonRef.current) {
            buttonRef.current.style.backgroundColor = hasCustomFilter ? "#0F054C" : "#FFFFFF";
            buttonRef.current.style.color = hasCustomFilter ? "#FFFFFF" : "#0F054C";
        }
    }, [hasCustomFilter, theme.palette.primary]);
    var resetMenuItem = function () {
        // renders the reset custom menu item
        return (_jsx(MenuItem, { onClick: function () { return handleApplyCustomMenu(null, null); }, children: _jsxs(Stack, { direction: "row", alignItems: "center", children: [_jsx("span", { style: { width: "32px" } }), _jsxs("span", { children: [t("electionEventScreen.common.reset"), " "] })] }) }, "reset-menu-item"));
    };
    /**
     * END added custom filter actions menu
     */
    var renderMenuItems = function () {
        var _a;
        var customFiltersList = [];
        var customFilters = ((_a = electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.presentation) === null || _a === void 0 ? void 0 : _a.custom_filters) || [];
        if (customFilters.length > 0) {
            // build the list of available filters
            customFiltersList = customFilters.map(function (item, index) {
                var label = item.label, filter = item.filter;
                return (_jsx(MenuItem, { onClick: function () { return handleApplyCustomMenu(filter, index + 1); }, children: _jsxs(Stack, { direction: "row", alignItems: "center", children: [_jsx("span", { style: { width: "32px" }, children: selectedCustomItemMenu && selectedCustomItemMenu === index + 1 ? (_jsx(Check, { sx: { mr: 1 } })) : null }), _jsx("span", { children: translate(label.i18n, i18n.language.split("-")[0], i18n.language.split("-")[0]) || t(label.name) })] }) }, "custom-filter-".concat(index)));
            });
        }
        return __spreadArray([resetMenuItem()], customFiltersList, true);
    };
    var handleImportVoters = function (documentId, sha256) { return __awaiter(void 0, void 0, void 0, function () {
        var currWidget, _a, data, errors, task_id, err_2;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setOpenImportDrawer(false);
                    currWidget = addWidget(ETasksExecution.IMPORT_USERS, undefined);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, importUsers({
                            variables: {
                                tenantId: tenantId,
                                documentId: documentId,
                                electionEventId: electionEventId || undefined,
                                sha256: sha256,
                            },
                        })];
                case 2:
                    _a = _c.sent(), data = _a.data, errors = _a.errors;
                    task_id = (_b = data === null || data === void 0 ? void 0 : data.import_users) === null || _b === void 0 ? void 0 : _b.task_execution.id;
                    setWidgetTaskId(currWidget.identifier, task_id);
                    refresh();
                    if (errors) {
                        updateWidgetFail(currWidget.identifier);
                        notify(t("electionEventScreen.import.importVotersError"), { type: "error" });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _c.sent();
                    console.log("Tenant ID: ".concat(tenantId));
                    console.log("Document ID: ".concat(documentId));
                    console.log("Election Event ID: ".concat(electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.id));
                    console.log("");
                    console.log("Error importing voters: ".concat(err_2));
                    updateWidgetFail(currWidget.identifier);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // Datafix voter edits are handled asynchronously by a task; show a progress
    // widget for it. Non-Datafix edits return no task, so this is not called.
    var handleEditUserTask = function (taskExecutionId) {
        var currWidget = addWidget(ETasksExecution.EDIT_USER, undefined);
        setWidgetTaskId(currWidget.identifier, taskExecutionId, refresh);
    };
    var listFields = useMemo(function () {
        var basicInfoFields = [];
        var attributesFields = [];
        var omitFields = ["id", "email_verified", "email"];
        visibleUserAttributes === null || visibleUserAttributes === void 0 ? void 0 : visibleUserAttributes.forEach(function (attr) {
            if (attr.name && userBasicInfo.includes(attr.name)) {
                basicInfoFields.push(attr);
            }
            else if (attr.name === SUPPORT_MATERIALS_ACKNOWLEDGED) {
                // Has its own dedicated boolean column below; must not be
                // auto-omitted like other Keycloak-attribute-derived columns.
            }
            else {
                omitFields.push("attributes['".concat(attr.name, "']"));
                attributesFields.push(attr);
            }
        });
        return { basicInfoFields: basicInfoFields, attributesFields: attributesFields, omitFields: omitFields };
    }, [visibleUserAttributes]);
    var renderFields = function (fields) {
        var allFields = fields.map(function (attr) {
            var _a;
            if (isSecretAttribute(attr))
                return null;
            if (attr.name === AUTHORIZED_ELECTION_IDS)
                return null;
            if (attr.name === DISABLE_COMMENT)
                return null;
            if (attr.name === VOTED_CHANNEL)
                return null;
            if (((_a = attr.annotations) === null || _a === void 0 ? void 0 : _a.inputType) === "html5-date") {
                return (_jsx(FunctionField, { source: "attributes['".concat(attr.name, "']"), label: getTranslationLabel(attr.name, attr.display_name, t), render: function (record, source) {
                        return (_jsx(CustomDateField, { base: "attributes", source: "".concat(attr.name), label: getTranslationLabel(attr.name, attr.display_name, t), emptyText: "-" }, attr.name));
                    } }, attr.name));
            }
            else if (attr.multivalued) {
                return (_jsx(FunctionField, { label: getTranslationLabel(attr.name, attr.display_name, t), render: function (record, source) {
                        var value = attr.name && userBasicInfo.includes(attr.name)
                            ? record[attr.name]
                            : (attr === null || attr === void 0 ? void 0 : attr.name)
                                ? record.attributes[attr === null || attr === void 0 ? void 0 : attr.name]
                                : "-";
                        return (_jsx(_Fragment, { children: value ? (value.map(function (item, index) { return (_jsx(StyledChip, { label: item }, index)); })) : (_jsx(StyledNull, { children: "-" })) }));
                    } }, attr.name));
            }
            return (_jsx(TextField, { source: attr.name && userBasicInfo.includes(attr.name)
                    ? attr.name
                    : "attributes['".concat(attr.name, "']"), label: getTranslationLabel(attr.name, attr.display_name, t), emptyText: "-" }, attr.name));
        });
        localStorage.removeItem("RaStore.preferences.".concat(getPreferenceKey(location.pathname, "voters"), ".datagrid.availableColumns"));
        return allFields;
    };
    useEffect(function () {
        if (location.pathname.includes("user-roles")) {
            setUserType("user");
        }
        else {
            setUserType("voter");
        }
    }, [location.pathname]);
    var checkUserEmailAndPhoneNumber = function () {
        if (userRecord) {
            var email = userRecord === null || userRecord === void 0 ? void 0 : userRecord.email;
            var phoneNumber = userRecord === null || userRecord === void 0 ? void 0 : userRecord.attributes[PHONE_NUMBER_USER_ATTRIBUTE];
            if (email || phoneNumber) {
                return true;
            }
        }
        return false;
    };
    var checkSupportMaterialsViewed = function (record) {
        var _a, _b;
        var acknowledgedIds = (_b = (_a = record === null || record === void 0 ? void 0 : record.attributes) === null || _a === void 0 ? void 0 : _a[SUPPORT_MATERIALS_ACKNOWLEDGED]) !== null && _b !== void 0 ? _b : [];
        return (requiredSupportMaterialDocumentIds.length > 0 &&
            requiredSupportMaterialDocumentIds.every(function (documentId) {
                return acknowledgedIds.includes(documentId);
            }));
    };
    var checkIsVoted = function (record) {
        var _a;
        return ((_a = record === null || record === void 0 ? void 0 : record.votes_info) === null || _a === void 0 ? void 0 : _a.length)
            ? !electionId || record.votes_info.some(function (vote) { return vote.election_id === electionId; })
            : false;
    };
    var CustomListBody = function () {
        // `isLoading` => initial load, `isFetching` => subsequent loads (e.g. paging, filtering)
        var _a = useListContext(), isLoading = _a.isLoading, isFetching = _a.isFetching, perPage = _a.perPage, filterValues = _a.filterValues, page = _a.page, data = _a.data;
        // Keep track of the "previous" page/filters in a ref and whether they changed
        var prevStateRef = useRef({ perPage: perPage, page: page, filterValues: filterValues });
        var _b = useState(false), filtersChanged = _b[0], setFiltersChanged = _b[1];
        // 1. Compare current page and filters with previous
        //    Detect when filters/page change, and set filtersChanged=true
        useEffect(function () {
            var prev = prevStateRef.current;
            var changed = prev.perPage !== perPage ||
                prev.page !== page ||
                !isEqual(prev.filterValues, filterValues);
            if (changed) {
                setFiltersChanged(true);
            }
            prevStateRef.current = { perPage: perPage, page: page, filterValues: filterValues };
        }, [perPage, page, filterValues]);
        // 2. Detect when the fetch is complete so we can reset filtersChanged if it was set
        useEffect(function () {
            if (!isFetching && filtersChanged) {
                setFiltersChanged(false);
            }
        }, [isFetching, filtersChanged]);
        var hasAuthorizedElectionIdsAttributes = useMemo(function () { return visibleUserAttributes === null || visibleUserAttributes === void 0 ? void 0 : visibleUserAttributes.find(function (attr) { return attr.name === AUTHORIZED_ELECTION_IDS; }); }, [visibleUserAttributes]);
        if (isLoading || (isFetching && filtersChanged)) {
            return _jsx(TableSkeleton, { rowCount: perPage });
        }
        return (_jsxs(_Fragment, { children: [visibleUserAttributes && (_jsxs(DataGridContainerStyle, { header: ThreeStateDatagridHeader, preferenceKey: getPreferenceKey(location.pathname, "voters"), omit: listFields.omitFields, isOpenSideBar: isOpenSidebar, bulkActionButtons: _jsx(BulkActions, {}), rowClick: false, children: [_jsx(TextField, { source: "id", sx: { display: "block", width: "280px" } }), _jsx(BooleanField, { source: "email_verified", label: String(t("usersAndRolesScreen.users.fields.emailVerified")) }), _jsx(BooleanField, { source: "enabled", label: String(t("usersAndRolesScreen.users.fields.enabled")) }), renderFields(listFields.basicInfoFields), electionEventId && (_jsx(FunctionField, { label: String(t("usersAndRolesScreen.users.fields.area")), render: function (record) {
                                var _a, _b, _c;
                                return ((_a = record === null || record === void 0 ? void 0 : record.area) === null || _a === void 0 ? void 0 : _a.name) ? (_jsx(Chip, { label: (_c = (_b = record === null || record === void 0 ? void 0 : record.area) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : "" })) : ("-");
                            } })), electionEventId && hasAuthorizedElectionIdsAttributes && (_jsx(ReferenceArrayField, { label: String(t("usersAndRolesScreen.users.fields.authorized-election-ids")), source: "attributes.authorized-election-ids", reference: "sequent_backend_election_by_external_id", queryOptions: {
                                meta: { filter: { election_event_id: electionEventId } },
                            }, children: _jsx(SingleFieldList, { linkType: false, children: _jsx(FunctionField, { render: function (e) { return (_jsx(Chip, { label: aliasRenderer(e) }, e.id)); } }) }) })), renderFields(listFields.attributesFields), electionEventId && isDatafixEvent && (_jsx(FunctionField, { source: "attributes['".concat(VOTED_CHANNEL, "']"), label: String(t("usersAndRolesScreen.users.fields.voted-channel")), render: function (record) {
                                var _a;
                                var values = (_a = record === null || record === void 0 ? void 0 : record.attributes) === null || _a === void 0 ? void 0 : _a[VOTED_CHANNEL];
                                var channel = Array.isArray(values)
                                    ? values[values.length - 1]
                                    : values;
                                return channel && channel !== ATTR_RESET_VALUE ? channel : "-";
                            } })), electionEventId && showVoterListSync && isDatafixEvent && (_jsx(FunctionField, { source: "attributes['".concat(DISABLE_COMMENT, "']"), label: String(t("usersAndRolesScreen.users.fields.disable-comment")), render: function (record) {
                                var _a;
                                var values = (_a = record === null || record === void 0 ? void 0 : record.attributes) === null || _a === void 0 ? void 0 : _a[DISABLE_COMMENT];
                                var comment = Array.isArray(values)
                                    ? values[values.length - 1]
                                    : values;
                                return comment && comment !== ATTR_RESET_VALUE ? comment : "-";
                            } })), electionEventId && (_jsx(FunctionField, { source: "has_voted", label: String(t("usersAndRolesScreen.users.fields.has_voted")), render: function (record, source) {
                                var newRecord = __assign({ has_voted: checkIsVoted(record) }, record);
                                return source ? (_jsx(BooleanField, { record: newRecord, source: source })) : null;
                            } })), electionEventId && isSupportMaterialsMandatory && (_jsx(FunctionField, { source: "attributes['".concat(SUPPORT_MATERIALS_ACKNOWLEDGED, "']"), label: String(t("usersAndRolesScreen.users.fields.support_materials_viewed")), render: function (record, source) {
                                var newRecord = __assign({ support_materials_viewed: checkSupportMaterialsViewed(record) }, record);
                                return source ? (_jsx(BooleanField, { record: newRecord, source: "support_materials_viewed" })) : null;
                            } })), !canEditVoters &&
                            !canDeleteVoters &&
                            !canSendTemplates &&
                            !canManuallyVerify &&
                            !canGenerateVoterInformationLetter &&
                            !canChangePassword &&
                            !showVotersLogs ? null : (_jsx(WrapperField, { source: "actions", label: "Actions", children: _jsx(ListActionsMenu, { actions: actions }) }))] })), showVotersFilters && (_jsx(Menu, { id: "custom-filters-menu", anchorEl: anchorEl, open: openCustomMenu, onClose: handleCloseCustomMenu, MenuListProps: {
                        "aria-labelledby": "basic-button",
                    }, children: renderMenuItems() }))] }));
    };
    return (_jsxs(_Fragment, { children: [_jsx(List, { resource: "user", storeKey: "".concat(getPreferenceKey(location.pathname, "voters")), queryOptions: {
                    refetchInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
                }, empty: hasCustomFilter ? false : _jsx(Empty, {}), actions: _jsx(ListActions, { withColumns: showVotersColumns, preferenceKey: getPreferenceKey(location.pathname, "voters"), withFilter: showVotersFilters, withImport: userType
                        ? userType === "voter"
                            ? canImportVoters
                            : canImportUsers
                        : false, doImport: handleImport, withExport: canExportVoters, doExport: handleExport, isExportDisabled: openExport, open: openDrawer, setOpen: setOpenDrawer, Component: _jsx(CreateUser, { electionEventId: electionEventId, close: handleClose, rolesList: rolesList || [], userAttributes: visibleUserAttributes || [], userAttributeGroups: userAttributeGroups }), withComponent: canCreateVoters, extraActions: __spreadArray(__spreadArray([], listActions, true), (electionEventId && showVoterListSync
                        ? [
                            _jsxs(Button, { onClick: function () { return setOpenReconciliationWizard(true); }, children: [_jsx(SyncAltIcon, { sx: { mr: 1 } }), t("reconciliation.menuButton")] }, "datafix-reconciliation-sync"),
                        ]
                        : []), true) }), filter: __assign(__assign({}, myFilters), permanentFilters), aside: aside, filters: Filters, disableSyncWithLocation: true, children: _jsx(CustomListBody, {}) }), _jsx(ResourceListStyles.Drawer, { anchor: "right", open: open, onClose: handleClose, children: _jsx(EditUser, { id: recordIds[0], electionEventId: electionEventId, electionId: electionId, close: handleClose, rolesList: rolesList || [], userAttributes: visibleUserAttributes || [], userAttributeGroups: userAttributeGroups, record: userRecord, onTaskLaunched: handleEditUserTask }) }), _jsx(ResourceListStyles.Drawer, { anchor: "right", open: openSendTemplate, onClose: handleClose, children: _jsx(SendTemplate, { ids: recordIds, audienceSelection: audienceSelection, electionEventId: electionEventId, close: handleClose, secretAttributeNames: secretAttributeNames }) }), _jsx(ResourceListStyles.Drawer, { anchor: "right", open: openNew, onClose: handleClose, children: _jsx(CreateUser, { electionEventId: electionEventId, close: handleClose, rolesList: rolesList || [], userAttributes: visibleUserAttributes || [], userAttributeGroups: userAttributeGroups }) }), _jsx(Dialog, { variant: "warning", open: openDeleteModal, ok: String(t("common.label.delete")), cancel: String(t("common.label.cancel")), title: String(t("common.label.warning")), handleClose: function (result) {
                    if (result) {
                        confirmDeleteAction();
                    }
                    setOpenDeleteModal(false);
                }, children: t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".delete.body")) }), _jsxs(Dialog, { variant: "warning", open: openManualVerificationModal, okEnabled: function () {
                    return checkUserEmailAndPhoneNumber() && !documentId;
                }, ok: String(t("usersAndRolesScreen.voters.manualVerification.verify")), cancel: String(t("common.label.cancel")), title: String(t("common.label.warning")), errorMessage: checkUserEmailAndPhoneNumber()
                    ? undefined
                    : t("usersAndRolesScreen.voters.manualVerification.noEmailOrPhone"), handleClose: function (result) {
                    if (result) {
                        confirmManualVerificationAction();
                        return;
                    }
                    setOpenManualVerificationModal(false);
                }, children: [t("usersAndRolesScreen.voters.manualVerification.body"), _jsxs(FormStyles.ReservedProgressSpace, { children: [documentId ? _jsx(FormStyles.ShowProgress, {}) : null, documentId ? (_jsx(DownloadDocument, { documentId: documentId, electionEventId: electionEventId !== null && electionEventId !== void 0 ? electionEventId : "", fileName: "manual-verify-".concat(electionEventId, "-").concat(documentId, ".pdf"), onDownload: function () {
                                    console.log("onDownload called");
                                    notify(t("usersAndRolesScreen.voters.notifications.manualVerificationSuccess"), {
                                        type: "success",
                                    });
                                    setOpenManualVerificationModal(false);
                                    setDocumentId(null);
                                } })) : null] })] }), electionEventId && showVoterListSync ? (_jsx(ReconciliationWizard, { open: openReconciliationWizard, electionEventId: electionEventId, onClose: function () { return setOpenReconciliationWizard(false); } })) : null, _jsx(ImportDataDrawer, { open: openImportDrawer, closeDrawer: function () { return setOpenImportDrawer(false); }, title: "electionEventScreen.import.title", subtitle: "electionEventScreen.import.subtitle", paragraph: "electionEventScreen.import.votersParagraph", doImport: handleImportVoters, errors: null }), _jsx(Dialog, { variant: "warning", open: openDeleteBulkModal, ok: String(t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".delete.okSelected"), { count: deleteScope.selectedCount })), cancel: String(t("common.label.cancel")), title: String(t("common.label.warning")), middleActions: electionEventId && deleteScope.matchingCount > deleteScope.selectedCount
                    ? [
                        _jsx(Button, { variant: "warning", disabled: deletingBulk, onClick: function () {
                                if (deletingBulk) {
                                    return;
                                }
                                confirmDeleteBulkAction(true);
                                setOpenDeleteBulkModal(false);
                                unselectAll();
                            }, children: t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".delete.okAllMatching")) }, "delete-all-matching"),
                    ]
                    : [], handleClose: function (result) {
                    if (result) {
                        confirmDeleteBulkAction(false);
                    }
                    setOpenDeleteBulkModal(false);
                    unselectAll();
                }, children: t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".delete.").concat(electionEventId && deleteScope.matchingCount > deleteScope.selectedCount
                    ? "bulkBodyChoose"
                    : "bulkBodySelected"), { count: deleteScope.selectedCount }) }), _jsxs(Dialog, { variant: "info", open: openExport, ok: String(t("common.label.export")), okEnabled: function () { return !exporting; }, cancel: String(t("common.label.cancel")), title: String(t("common.label.export")), handleClose: function (result) {
                    if (result) {
                        confirmExportAction();
                    }
                    else {
                        setExportDocumentId(undefined);
                        setExporting(false);
                        setOpenExport(false);
                    }
                }, children: [t("common.export"), electionEventId &&
                        canReadVoterSecretAttributes &&
                        secretAttributeNames.length > 0 && (_jsxs(Box, { sx: { mt: 2 }, children: [_jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: includeSecretAttributes, onChange: function (event) {
                                        return setIncludeSecretAttributes(event.target.checked);
                                    } }), label: String(t("usersAndRolesScreen.voters.secretAttribute.includeInExport")) }), includeSecretAttributes && (_jsx(Typography, { color: "warning.main", variant: "body2", children: t("usersAndRolesScreen.voters.secretAttribute.exportWarning") }))] })), exporting ? (_jsxs(FormStyles.ReservedProgressSpace, { children: [_jsx(FormStyles.ShowProgress, {}), exportDocumentId ? (_jsx(DownloadDocument, { documentId: exportDocumentId, electionEventId: electionEventId !== null && electionEventId !== void 0 ? electionEventId : "", fileName: "users-export.csv", onDownload: function () {
                                    console.log("onDownload called");
                                    setExportDocumentId(undefined);
                                    setExporting(false);
                                    setOpenExport(false);
                                } })) : null] })) : null] }), _jsx(Dialog, { fullWidth: true, variant: "info", maxWidth: "xl", title: String(t("usersAndRolesScreen.voters.logs.label")), ok: String(t("common.label.close")), open: openUsersLogsModal, handleClose: handleClose, children: _jsx(_Fragment, { children: recordIds && recordIds.length > 0 && (_jsx(ElectoralLogList, { electionEventId: electionEventId, showActions: false, filterToShow: ElectoralLogFilters.USER_ID, filterValue: (_e = recordIds[0]) === null || _e === void 0 ? void 0 : _e.toString() })) }) }), _jsxs(Dialog, { variant: "info", open: openVoterInformationLetter, ok: String(t("usersAndRolesScreen.voters.voterInformationLetter.generate")), okEnabled: function () { return !generatingVoterInformationLetter; }, cancel: String(t("common.label.cancel")), title: String(t("usersAndRolesScreen.voters.voterInformationLetter.label")), handleClose: function (result) {
                    if (result) {
                        void confirmVoterInformationLetter();
                        return;
                    }
                    setOpenVoterInformationLetter(false);
                    setRecordIds([]);
                }, children: [_jsx(Typography, { children: t("usersAndRolesScreen.voters.voterInformationLetter.confirmation") }), _jsx(FormStyles.ReservedProgressSpace, { children: generatingVoterInformationLetter ? _jsx(FormStyles.ShowProgress, {}) : null })] }), _jsx(Dialog, { fullWidth: true, variant: "info", maxWidth: "sm", title: String(t("tasksScreen.documentAccess.title")), ok: String(t("common.label.close")), open: Boolean(voterInformationLetterPassword), handleClose: function () { return setVoterInformationLetterPassword(undefined); }, children: voterInformationLetterPassword ? (_jsx(VoterInformationLetterPasswordAccess, { pdfPassword: voterInformationLetterPassword })) : null }), openEditPassword && (_jsx(EditPassword, { open: openEditPassword, handleClose: function () { return setOpenEditPassword(false); }, id: recordIds[0], electionEventId: electionEventId }))] }));
};
export var TableSkeleton = function (_a) {
    var _b = _a.rowCount, rowCount = _b === void 0 ? 10 : _b, _c = _a.columnWidths, columnWidths = _c === void 0 ? ["10%", "20%", "20%", "10%", "15%", "25%"] : _c;
    return (_jsx(Box, { sx: { width: "100%", p: 2 }, children: Array.from({ length: rowCount }).map(function (_, rowIndex) { return (_jsx(Box, { sx: { display: "flex", gap: 2, mb: 1, alignItems: "center" }, children: columnWidths.map(function (width, colIndex) { return (_jsx(Skeleton, { variant: "text", sx: { width: width, height: 24 } }, "".concat(rowIndex, "-").concat(colIndex))); }) }, rowIndex)); }) }));
};
var templateObject_1, templateObject_2, templateObject_3;
